import { createAction } from '@ngrx/store';

import { SITE_CONTEXT_ACTIONS } from '../site-context-actions.type';

export const changeCountryAction = createAction(SITE_CONTEXT_ACTIONS.CHANGE_COUNTRY);
